import request from '@/utils/request'

/**
 * 获取用户列表数据
 */
export const getMediaProductList = data => {
  return request({
    url: '/mj/pro/list',
    params: data
  })
}

export const getMediaProductAll = () => {
  return request({
    url: '/mj/pro/listAll'
  })
}

export const listAllPayMode = () => {
  return request({
    url: '/mj/pro/listAllPayMode'
  })
}

export const listAllPre = () => {
  return request({
    url: '/mj/pro/listAllPre'
  })
}

export const getProductById = (data) => {
  return request({
    url: '/mj/pro/getProductById',
    method: 'POST',
    params: data
  })
}

export const addPro = data => {
  return request({
    url: '/mj/pro/save',
    method: 'POST',
    data
  })
}

export const updatePro = data => {
  return request({
    url: '/mj/pro/update',
    method: 'POST',
    data
  })
}

export const updateInfo = data => {
  return request({
    url: '/mj/pro/updateInfo',
    method: 'POST',
    data
  })
}

export const search = data => {
  return request({
    url: '/mj/pro/search',
    method: 'POST',
    data
  })
}
